"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var Rating_1 = __importDefault(require("@material-ui/lab/Rating"));
var styles_1 = require("@material-ui/core/styles");
var react_redux_1 = require("react-redux");
var icons_1 = require("../../../../common/icons");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var constants_1 = require("../../../../common/constants");
var activityService_1 = require("../../../../app/services/activityService");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var store_1 = require("../../../../app/store");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        root: (_a = {
                margin: theme.spacing(1),
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.youwell.shapes.borderRadiusRounder,
                padding: theme.spacing(5, 6)
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(3),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2, 1),
            },
            _a),
        heading: (_b = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: theme.spacing(0, 0, 4, 0)
            },
            _b[theme.breakpoints.down('sm')] = {
                marginBottom: theme.spacing(3),
            },
            _b),
        title: {
            borderLeft: theme.youwell.borders.secondary,
            padding: theme.spacing(1, 2),
        },
        formInput: {
            margin: theme.spacing(0.5),
        },
        durationTableCell: {
            paddingRight: theme.spacing(1),
            width: 120,
        },
        selectCategory: {
            minWidth: 160,
            '& :focus': {
                backgroundColor: theme.palette.background.default,
            },
        },
        activityActions: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: theme.spacing(6),
        },
        cancelBtn: {
            marginRight: theme.spacing(1),
        },
        form: {
            margin: theme.spacing(1),
        },
        textField: {
            marginBottom: theme.spacing(3),
        },
        durationAdornment: {
            marginLeft: theme.spacing(1),
        },
        effortValues: {
            display: 'flex',
            alignItems: 'center',
        },
    });
}, { name: 'AddEditActivityDialog' });
var AddEditActivityDialog = function (_a) {
    var activity = _a.activity, onClose = _a.onClose;
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var translate = (0, translate_1.default)();
    var patientId = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.auth.profileData) === null || _a === void 0 ? void 0 : _a.id; });
    var _b = React.useState(__assign({}, activity)), activityData = _b[0], setActivityData = _b[1];
    if (!activity || !patientId) {
        return null;
    }
    var addActivity = function () {
        var newActivity = {
            patientId: patientId,
            category: activityData.category,
            activity: activityData.activity,
            date: activityData.date,
            durationInMinutes: Number(activityData.durationInMinutes) || 0,
            effortRating: activityData.effortRating,
        };
        (0, activityService_1.insertActivityData)(dispatch, newActivity, { callback: onClose });
    };
    var updateActivity = function () {
        var updatedActivity = {
            id: activity.id,
            category: activityData.category,
            activity: activityData.activity,
            date: activityData.date,
            durationInMinutes: Number(activityData.durationInMinutes) || 0,
            effortRating: activityData.effortRating,
        };
        (0, activityService_1.updateActivitiesData)(dispatch, updatedActivity, { callback: onClose });
    };
    var addOrUpdate = function () {
        if (activity.id) {
            updateActivity();
        }
        else {
            addActivity();
        }
    };
    var onEnter = function (e) {
        if (e.key === 'Enter' && activityData.category && activityData.activity && activityData.durationInMinutes) {
            addOrUpdate();
        }
    };
    var today = new Date();
    var todayIso = (0, dateUtils_1.isoDateWithoutTimezone)(today);
    var isPastDate = todayIso >= (0, dateUtils_1.isoDate)(activity.date);
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.heading },
            React.createElement(core_1.Typography, { className: classes.title, variant: "subtitle2" }, "".concat(translate('activityDiary.addActivity'), " | ").concat((0, dateUtils_1.datestamp)(activity.date))),
            React.createElement(core_1.IconButton, { onClick: onClose },
                React.createElement(icons_1.CancelOutlinedIcon, null))),
        React.createElement("div", { className: classes.form },
            React.createElement(core_1.TextField, { className: classes.textField, variant: "outlined", value: activityData.category || '', onChange: function (e) { return setActivityData(__assign(__assign({}, activityData), { category: e.target.value })); }, select: true, label: translate('activityDiary.category'), InputLabelProps: { shrink: true }, fullWidth: true }, Object.keys(constants_1.activityCategories).map(function (categoryKey) { return (React.createElement(core_1.MenuItem, { key: categoryKey, value: constants_1.activityCategories[categoryKey] }, translate("activityDiary.categories.".concat(constants_1.activityCategories[categoryKey])))); })),
            React.createElement(core_1.TextField, { className: classes.textField, variant: "outlined", label: translate('activityDiary.activity'), value: activityData.activity || '', onChange: function (e) { return setActivityData(__assign(__assign({}, activityData), { activity: e.target.value })); }, placeholder: translate('activityDiary.activityPlaceholder'), InputLabelProps: { shrink: true }, fullWidth: true }),
            React.createElement(core_1.TextField, { className: classes.textField, variant: "outlined", label: translate('activityDiary.duration'), type: "number", value: activityData.durationInMinutes || '', onChange: function (e) { return setActivityData(__assign(__assign({}, activityData), { durationInMinutes: Math.abs(Number(e.target.value)).toString() })); }, placeholder: translate('activityDiary.durationPlaceholder'), onKeyPress: onEnter, InputProps: { endAdornment: React.createElement("span", { className: classes.durationAdornment }, translate('time.minutes')) }, InputLabelProps: { shrink: true }, fullWidth: true }),
            isPastDate && activityData.id && (React.createElement(React.Fragment, null,
                React.createElement(core_1.Typography, { variant: "caption" }, "".concat(translate('activityDiary.effort'), ": ")),
                React.createElement("div", { className: classes.effortValues },
                    React.createElement(core_1.IconButton, { color: activityData.effortRating === -1 ? 'primary' : 'default', onClick: function () { return setActivityData(__assign(__assign({}, activityData), { effortRating: -1 })); } },
                        React.createElement(icons_1.NotInterestedIcon, null)),
                    React.createElement(Rating_1.default, { name: "effortRating-edit", onChange: function (e, r) { return setActivityData(r !== null ? __assign(__assign({}, activityData), { effortRating: r }) : __assign(__assign({}, activityData), { effortRating: undefined })); }, color: "primary", value: activityData.effortRating }))))),
        React.createElement("div", { className: classes.activityActions },
            React.createElement(core_1.Button, { className: classes.cancelBtn, variant: "outlined", color: "primary", onClick: onClose }, translate('activityDiary.cancel')),
            React.createElement(core_1.Button, { disabled: !(activityData.category && activityData.activity), variant: "contained", color: "primary", onClick: addOrUpdate }, translate('activityDiary.save')))));
};
exports.default = AddEditActivityDialog;
